export default __webpack_public_path__ + "static/media/pictogramInternational40.067029fb.svg";